var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    r: 15.022,
    transform: "matrix(-1 0 0 1 15.5 15.5161)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8097 15.5156L15.5003 20.2101L11.1909 15.5156L9.86707 16.8394L15.5003 22.4727L21.1335 16.8394L19.8097 15.5156Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5005 20.2097V8.00439",
    stroke: "black",
    strokeWidth: 1.87775
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "download-arrow.722b3f60b202794118b9defaee3d7470.svg";